import { IHomeHealthRepository } from "../../adapters/driven/repositories/homeHealthRepository";

export const HomeHealthServiceImplFactory = ({
  homeHealthRepository,
}: {
  homeHealthRepository: IHomeHealthRepository;
}) => {
  const getSinglePatientInfo: IGetSinglePatientInfo = async ({
    patient_id,
  }) => {
    try {
      const response = await homeHealthRepository.getSinglePatientInfo({
        patient_id,
      });
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getPatientGraphData: IGetPatientGraphData = async ({ patient_id }) => {
    try {
      const response = await homeHealthRepository.getPatientGraphData({
        patient_id,
      });
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getSelectedFacilityPatientList: IGetSelectedFacilityPatientList =
    async ({ clinic_id }) => {
      try {
        const response =
          await homeHealthRepository.getSelectedFacilityPatientList({
            clinic_id,
          });
        return {
          success: true,
          data: response,
        };
      } catch (error) {
        return {
          success: false,
          error: { message: (error as unknown as Error).message },
        };
      }
    };

  return {
    getSinglePatientInfo,
    getPatientGraphData,
    getSelectedFacilityPatientList,
  };
};
